import { useEffect, useState } from 'react';
import { fetchDataQuality } from '../services/dataQuality.api';
import { makeDefaultRange14 } from '../utils/dateRanges';

export function useDataQuality({ operator, unit, meter, fromDate, toDate }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    const controller = new AbortController();
    (async () => {
      try {
        setLoading(true);

        const defaultRange = makeDefaultRange14();
        const effectiveFrom = fromDate || defaultRange.start;
        const effectiveTo   = toDate   || defaultRange.end;

        console.log('useDataQuality.fetch', { operator, unit, meter, from: effectiveFrom, to: effectiveTo });

        const res = await fetchDataQuality({
          operator,
          unit,
          meter,
          fromDate: effectiveFrom,
          toDate:   effectiveTo,
        }, controller.signal);
        if (alive) setData(res || []);
      } catch (e) {
        if (alive) setError(e);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; controller.abort(); };
  }, [operator, unit, meter, fromDate, toDate]);

  return { data, loading, error };
}
